import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedProducts from './components/FeaturedProducts';
import FeaturedPacks from './components/FeaturedPacks';
import CategoriesSection from './components/CategoriesSection';
import BenefitsSection from './components/BenefitsSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <BenefitsSection />
      <FeaturedPacks />
      <FeaturedProducts />
      <CategoriesSection />
      <CTASection />
      <Footer />
    </div>
  );
}